import React, { Component } from 'react';
import FetchHelper from '../../../helpers/fetchHelper';
import notification from '../../../components/notification';
//import IntlMessages from '../../../components/utility/intlMessages';
import { Spin, AutoComplete, Select, Input } from 'antd';
const {Option} = Select
const AutoCompleteOption = AutoComplete.Option;
export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading:false,
      value:'',
      flagInitial:false,
      initialValue:null
    };
    this.retrieveData = this.retrieveData.bind(this);
    this.deleteValue = this.deleteValue.bind(this);
    this.setInputValue = this.setInputValue.bind(this);
  }
  componentDidMount(){
    // PROPS
    // * uri = url para traer los datos
    // * uriFunction = funcion url para traer los datos
    // * reload = recarga onChange
    // * filterDefault = filtro por default
    // * getValue = value de autocomplete
    // * getValueFunction = funcion value de autocomplete
    // * onSelect = funcion onSelect
    // * onSearch = funcion onSearch
    // * placeholder = placeholder
    // * keyData = id de object
    if (!this.props.reload) {
      var search = ' '
      if (this.props.initialValue) {
        search = this.props.initialValue;
      }
      if(search){
        this.retrieveData(search);
      }
    }
    if (this.props.initialValue && !this.state.flagInitial) {
      this.handleChange(this.props.initialValue, true)
    }
  }
  componentDidUpdate(prevProps, prevState){
    if (this.props.initialValue) {
      if (this.props.initialValue !== this.state.initialValue) {
        this.setState({initialValue:this.props.initialValue});
      }
    } else if (prevProps.initialValue && !this.props.initialValue) {
      this.setState({initialValue:' '}, () => {
        this.deleteValue(true);
      });
    }
  }


  retrieveData(value) {
    this.searching = value;
    var uri = null;
    if (this.props.uri) {
      uri = this.props.uri
    }
    if (this.props.uriFunction) {
      uri = this.props.uriFunction(value)
    }
    if(!uri){
      return;
    }
    this.timeoutHandle = setTimeout(()=>{
      if (this.searching === value) {
        this.setState({loading:true});
        if (value) {
            FetchHelper.httpRequest('GET', uri).then(result => {
              if (result.error) {
                if (this.props.handleError){
                  this.props.handleError(result)
                } else{
                  notification('error', result.error_msg);
                }
              } else {
                if (this.searching === value) {
                  if (result.data && result.data.datos) {
                    this.setState({data:result.data.datos, loading:false}, () => {
                        this.setState({flagInitial:false})
                    });
                  } else {
                    this.setState({data:result.data, loading:false},() => {
                      this.setState({flagInitial:false})
                    });
                  }
                }
              }
            });
        } else {
          if (this.searching === value) {
            this.setState({data:[], loading:false});
          }
        }
      }
    }, 500);
  }
  handleChange = (value, first=false) => {
    this.setState({
      value:value,
      flagInitial:first
    }, () => {
      if (this.props.reload || this.props.reloadInitial) {
        this.retrieveData(value)
      }
    });
  }
  deleteValue(reload=false){
    this.setState({value:null, data:[]}, () => {
      this.setInputValue(null);
      if(reload){
        this.retrieveData(this.state.initialValue);
      }
    });
  }
  setInputValue(value){
    if (this.autocomplete && this.autocomplete.select && this.autocomplete.select.rcSelect && this.autocomplete.select.rcSelect.setInputValue) {
      this.autocomplete.select.rcSelect.setInputValue(value)
    }
  }
  getValue(item){
    var value = 'NO VALUE'
    if (this.props.getValue) {
      value = item[this.props.getValue]
    }
    if (this.props.getValueFunction) {
      value = this.props.getValueFunction(item)
    }
    return value;
  }

  isDisabled = (item)=>{
    let disable = false
    if(this.props.isDisabled){
      disable = this.props.isDisabled(item)
    }
    return disable
  }

  getOptions(){
    const { data, loading, value } = this.state;
    const { keyData } = this.props
    var options = [];
    if (!loading) {

      options = Array.isArray(data) ?
       data.map(item => (
         <AutoCompleteOption key={item[keyData] ? item[keyData] : 'NO-KEY'} disabled={this.isDisabled(item)}>
          {item[keyData]?this.getValue(item):'NO-KEY'}
        </AutoCompleteOption>
      )):
      []
      ;

      if (options.length <= 0) {
        options = [<AutoCompleteOption disabled={true} key="notFound">
            No se encontraron
        </AutoCompleteOption>]
      }
    }
    if (loading) {
      options = [<AutoCompleteOption disabled={true} key="loading">
          <Spin size="small"/>
      </AutoCompleteOption>];
    }
    return options
  }
  saveRef = (obj, name) => {
    this[name] = obj;
  }
  handleKeyPress = (e) => {
    if ((e.target.value !== this.state.value) || e.key === 'Backspace') {
      var value = e.target.value;
      if (this.props.toUpperCase) {
        value = e.target.value.toUpperCase();
        this.setInputValue(value)
      }
      if (this.props.onlyNumbers) {
        value = e.target.value.replace(/[^\d]/,'')
        this.setInputValue(value)
      }
      if (this.props.maxLength) {
        if (value.length > this.props.maxLength && e.key !== 'Backspace') {
          value = e.target.value.slice(0, this.props.maxLength)
          this.setInputValue(value)
          return
        }
      }
      this.handleChange(value)
    }
  }
  render() {
    const { value, flagInitial } = this.state;
    const options = this.getOptions();
    var filter = false
    if (this.props.filterDefault) {
      filter = {
        filterOption:(inputValue, option) => {
          if (inputValue.toUpperCase && option.props.children.toUpperCase) {
            return (
              option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
            )
          }
        }
      }
    }
    var properties = {
      style: {width:'100%'},
      dataSource: options,
      size: this.props.size,
      onSelect: this.props.onSelect,
      onSearch: this.props.onSearch,
      disabled: this.props.disabled,
      placeholder: this.props.placeholder,
      allowClear: false
    }
    if (flagInitial) {
      properties['value'] = value;
    }
    return(
      <AutoComplete
        {...properties}
        ref={(e) => this.saveRef(e, 'autocomplete')}
        {...filter}
      >
        <Input
          className="custom"
          onKeyUp={this.handleKeyPress}
        />
      </AutoComplete>
    )

  }
}
